import * as React from 'react';
import { IconBase } from 'react-icons';
function DeprecatedChatsIcon(props, svgRef) {
    return (
        <IconBase viewBox="0 0 20 20" fill="currentColor" ref={svgRef} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.561 0H5.44A5.439 5.439 0 000 5.439V18.42C0 19.293.707 20 1.579 20H14.56A5.439 5.439 0 0020 14.561V5.44A5.439 5.439 0 0014.561 0zm0 17.544H2.456V5.439A2.982 2.982 0 015.44 2.456h9.122a2.982 2.982 0 012.983 2.983v9.122a2.982 2.982 0 01-2.983 2.983z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.86 11.228a1.228 1.228 0 100-2.456 1.228 1.228 0 000 2.456zM10 11.228a1.228 1.228 0 100-2.456 1.228 1.228 0 000 2.456zM6.14 11.228a1.228 1.228 0 100-2.456 1.228 1.228 0 000 2.456z"
            />
        </IconBase>
    );
}
const ForwardRef = React.forwardRef(DeprecatedChatsIcon);
export default ForwardRef;
